var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.60761 0 0 5.60761 0 12.5C0 19.3924 5.60761 25 12.5 25C19.3924 25 25 19.3924 25 12.5C25 5.60761 19.3924 0 12.5 0ZM12.5 17.1875L4.6875 9.375H9.375L12.5 12.5L15.625 9.375H20.3125L12.5 17.1875Z",
    fill: "#6495ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdrop);
export default __webpack_public_path__ + "static/media/arrowdrop.4724e9ab909be9d864c3c55c2a241f29.svg";
export { ForwardRef as ReactComponent };